export enum TemplateContentTypes {
  Transactional = 0,
  Marketing = 1,
}
